"use client"

import { useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "../../../store"
import geoInfo from "../../utils/geoInfo"
import { updateBusinessArea } from "../../../store/slices/businessAreasSlice"
import { searchFunction } from "../../commonfunctions/searchFunction"
import DropdownButtonForSearch from "../../Dropdowns/DropdownButtonForSearch"
import InputField from "../../inputfields/InputField"
import Image from "../../images/Image"

interface ComponentBusinessAssignedAreaProps {
  id: number
  onDelete: () => void
  showDelete: boolean
  index: number
}

export default function ComponentBusinessAssignedArea({
  id,
  onDelete,
  showDelete,
  index
}: ComponentBusinessAssignedAreaProps) {
  const dispatch = useDispatch()
  const businessArea = useSelector((state: RootState) =>
    state.businessAreas.areas.find((area) => area.id === id)
  )

  const provinceList = [...new Set(geoInfo.map((item) => item.Province))]
  const [provinces, setProvinces] = useState(provinceList)
  const [selectedProvince, setSelectedProvince] = useState(businessArea?.province || "")
  const [region, setRegion] = useState(businessArea?.region || "")

  useEffect(() => {
    if (businessArea) {
      setSelectedProvince(businessArea.province)
      setRegion(businessArea.region)
    }
  }, [businessArea])

  const getListOfData = (
    data: { [key: string]: any }[],
    selectedValue: string,
    key: string,
    requiredKey: string
  ): string[] => {
    return Array.from(
      new Set(
        data
          .filter((item) => item[key] === selectedValue)
          .map((item) => item[requiredKey])
      )
    );
  };

  const handleProvinceChange = (id: number, value: string) => {
    setSelectedProvince(value)
    const selectedRegion = getListOfData(geoInfo, value, "Province", "Region Name")
    const newRegion = selectedRegion[0]
    setRegion(newRegion)
    dispatch(updateBusinessArea({ id, province: value, region: newRegion }))
  }

  const handleSearchValue = (value: string) => {
    setProvinces(searchFunction(value, provinceList))
  }

  return (
    <div className="bg-blue-50 p-4 rounded-lg flex gap-4 justify-between items-center w-full">
      <div className="flex flex-wrap gap-4 w-full">
        <DropdownButtonForSearch
          labelName="Province (State)"
          id="Province"
          tabIndex={1}
          required={false}
          options={provinces}
          selectedValue={selectedProvince}
          onChange={(dropdownid, value) => handleProvinceChange(id, value)} // Ensure `id` is passed as a number
          handleSearchValue={handleSearchValue}
          modalStyle={' mb-5 w-1/3'}
          className={'w-full'}
        />
        <InputField
          inputItem={{
            labelName: "Region",
            id: "region",
          }}
          placeholder="Auto-filled based on province"
          value={region}
          disabled={true}
          tabIndex={3}
          maindivstyle={"w-1/3"}
          className={"w-full"}
        />
      </div>
      {showDelete && (
        <Image src="delete_blue" testId={`delete-business-area-${index}`} className="h-6 w-6 cursor-pointer" onClick={onDelete} />
      )}
    </div>
  )
}
